import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "settings-page-title" }

type Props = {
  /** 表示するタイトル */
  label: string;
};


export default /*@__PURE__*/_defineComponent({
  __name: 'SettingsPageTitle',
  props: {
    label: {}
  },
  setup(__props: any) {

/**
 * 設定ページのタイトル表示プロパティ
 */


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("h1", _hoisted_1, _toDisplayString(_ctx.label), 1))
}
}

})